exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-qr-page .modal-content[data-v-700eb292]{background:#fff;border-radius:10px}#modal-qr-page .modal-header[data-v-700eb292]{border-bottom:unset}#modal-qr-page .modal-title[data-v-700eb292]{font-style:normal;font-weight:600;font-size:20px;line-height:30px;color:#e61b33}#modal-qr-page #card-img[data-v-700eb292]{max-height:124px}#modal-qr-page #card-id[data-v-700eb292]{font-style:normal;font-weight:600;font-size:14px;line-height:25px;text-align:center;color:#282828}#modal-qr-page #card-label[data-v-700eb292]{font-style:normal;font-weight:300;font-size:14px;line-height:22px;text-align:center;color:#b4b4b4}", ""]);

// exports
